import { atom } from 'jotai';

export interface InviteCustomerFormData {
  accountId: string;
  email: string;
}

const getInitialFormData = (): InviteCustomerFormData => ({
  accountId: '',
  email: '',
});

export const $inviteCustomerDialogOpen = atom(false);
export const $inviteCustomerFormData =
  atom<InviteCustomerFormData>(getInitialFormData());

export const $openInviteCustomerDialog = atom(null, (_get, set) => {
  set($inviteCustomerFormData, getInitialFormData());
  set($inviteCustomerDialogOpen, true);
});

export const $closeInviteCustomerDialog = atom(null, (_get, set) => {
  set($inviteCustomerDialogOpen, false);
  set($inviteCustomerFormData, getInitialFormData());
});

export const $updateInviteCustomerForm = atom(
  null,
  (get, set, update: Partial<InviteCustomerFormData>) => {
    set($inviteCustomerFormData, {
      ...get($inviteCustomerFormData),
      ...update,
    });
  },
);

export const $inviteCustomerFormValid = atom((get) => {
  const form = get($inviteCustomerFormData);
  return form.accountId.trim() !== '' && form.email.trim() !== '';
});
